var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.footer]
  }, [_c('div', {
    staticClass: "new_footer",
    class: [_vm.$style.container]
  }, [_vm.synopsisVisible ? _c('div', [_c('div', {
    class: [_vm.$style.title]
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.platformTitle')) + "\n      ")]), _vm._v(" "), _c('Row', {
    class: [_vm.$style.link_list]
  }, _vm._l(_vm.datas, function (item, index) {
    return _c('Col', {
      key: index,
      class: [index > 1 ? _vm.$style.pointer_events_none : ''],
      attrs: {
        "span": index === 2 ? 12 : 4
      }
    }, _vm._l(item, function (child_item, child_index) {
      return _c('a', {
        key: '1-' + child_index,
        class: [_vm.$style.footer_link],
        style: {
          width: child_item.width ? child_item.width : '100%'
        },
        attrs: {
          "href": "javscript:;"
        },
        on: {
          "click": function ($event) {
            return _vm.fn_href(child_item);
          }
        }
      }, [_vm._v("\n            " + _vm._s(_vm.$t(child_item.title)) + "\n          ")]);
    }), 0);
  }), 1), _vm._v(" "), _c('div', {
    class: [_vm.$style.qrd_div]
  }, [_c('div', {
    class: [_vm.$style.qrd_item]
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('home.more')))]), _vm._v(" "), _c('img', {
    class: [_vm.$style.qrd_img],
    attrs: {
      "src": "https://image.kilimall.com/seller/qrd_gzh.jpg",
      "width": "100"
    }
  })])])], 1) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }